import { Container } from "statuo";
import { pickBy, merge } from "lodash";
import { get as getPageOptions } from "../../utilities/options";
import getResults from "../../../03-api/filtering/filter";
import addEndpointResponseTransform from "../transforms/add-endpoint-response";

const initialState = pickBy(
    merge(
      {},
      {
        NodeId: getPageOptions("NodeId") || "",
        Page: 1,
        Filters: [],
        SearchQuery: "",
        SearchRadius: 500,
      },
    ),
    (value) => value !== null,
  ),
  responseKey = "response",
  addEndpointResponseTransformConfig = {
    endpoint: getResults,
    omitKeys: [responseKey],
    stateKey: responseKey,
  };

export default class extends Container {
  constructor() {
    super({
      state: initialState,
      transforms: [
        addEndpointResponseTransform(addEndpointResponseTransformConfig),
      ],
    });
  }
}
